import { render, staticRenderFns } from "./BannerProExpired.vue?vue&type=template&id=11c5a2a3&"
import script from "./BannerProExpired.vue?vue&type=script&lang=js&"
export * from "./BannerProExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports